import React, { forwardRef } from 'react'
import { InputFieldProps } from './types'
import MaskedInput from './MaskedInput'
import BaseInput from './BaseInput'
import { useTranslation } from 'react-i18next'

export const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  function InputField(props, ref) {
    const { t } = useTranslation()

    const { mask, help } = props

    return mask ? (
      <MaskedInput {...props} help={t(help)} ref={ref} />
    ) : (
      <BaseInput {...props} help={t(help)} ref={ref} />
    )
  }
)
